import { useState, useEffect } from 'react';
import { getCommunicationService } from 'utils/communicationService';
export default function useSiteNoticeListener(isMobile) {
    var _a, _b;
    const [isSiteNoticeConflict, setIsSiteNoticeConflict] = useState(true);
    const communicationService = getCommunicationService();
    const context = window.SilverSurferSDK.getContext();
    const isAnon = (_b = (_a = context === null || context === void 0 ? void 0 : context.user) === null || _a === void 0 ? void 0 : _a.isAnon) !== null && _b !== void 0 ? _b : false;
    useEffect(() => {
        communicationService.on('[SiteNotice] Initialized', ({ isVisible }) => {
            if (!isVisible) {
                setIsSiteNoticeConflict(false);
            }
        });
        if (isMobile && isAnon) {
            setIsSiteNoticeConflict(false);
        }
    }, [communicationService]);
    return isSiteNoticeConflict;
}
